module.exports = __webpack_public_path__ + "static/media/1.f503f70e.jpg";